export default __webpack_public_path__ + "img/Montserrat-Black_e410a53.ttf";